// @ts-strict-ignore
import {capitalize} from 'common/util/string';
import {getReportName} from 'common/report/util';

import {userCookieUtils} from '../user-identity-from-cookie';
import {SearchResult} from './types';

export enum BrowseTrackedEvent {
  ClosedModal = `[Content Discovery] Report List - Close`,
  CreatorFilterMenuOpened = `[Content Discovery] Creator Filter Menu Opened`,
  FilterUpdated = `[Content Discovery] Filter Updated`,
  OpenDiscover = `[Content Discovery] Opened Discover Page`,
  ResultRightClicked = `[Content Discovery] Result Right-Clicked`,
  ResultSelected = `[Content Discovery] Result Selected`,
  SearchResultLoaded = `[Content Discovery] Search Result Loaded`,
  Sort = `[Content Discovery] Sort Search Results`,
  SuggestedCreatorSelected = `[Content Discovery] Suggested Creator Selected`,
  SwitchedResultMode = `[Content Discovery] Switched Results Mode`,
  StarterBoardPromptViewed = `[Starter Board] Upsell Prompt Viewed`,
  StarterBoardPromptButtonClicked = `[Starter Board] Upsell Prompt Button Clicked`,
}

export enum TypeaheadTrackedEvent {
  CreatorFilterSelected = `[Typeahead Search] Creator Filter Selected`,
  OpenTypeahead = `[Typeahead Search] Opened Typeahead`,
  RecentQuerySelected = `[Typeahead Search] Recent Query Selected`,
  RecentResultDeleted = `[Typeahead Search] Recent Result Deleted`,
  ResultSelected = `[Typeahead Search] Result Selected`,
  SearchResultLoaded = `[Typeahead Search] Search Result Loaded`,
  ShowAllSelected = `[Typeahead Search] Show All Selected`,
}

export enum SearchTrackedProperty {
  BrowseMode = `Browse Mode`,
  // represents the stage of content discovery, such as browse (opening and looking for content
  // getting recent results, and the result after searching for something)
  ContentDiscoveryType = `Content Discovery Type`,
  EventFilters = `Event Filters`, // event names
  IsOwner = `is owner`,
  NumCreatorFilters = `Number of creator filters`,
  Owner = `Owner`,
  OwnerFilters = `Ownership Filters`, // me, not me, anyone
  PhaseVersion = `Phase Version`,
  PopularityScore = `Popularity Score`,
  FinalScore = `Final Score`,
  QueryTime = `Query Time`,
  ReportDescription = `Result Description`,
  ReportFilters = `Report Type Filters`, // insights, funnels, etc
  ReportTitle = `Result Name`,
  ReportType = `Report name`, // type of the report, insights, funnels, etc
  ResultAmount = `Number of Results`,
  ResultsWithPopularity = `Results with popularity score`,
  ResultLink = `Result Link`,
  ResultMode = `Result Mode`,
  ResultPosition = `Result Position`,
  SearchAccessPoint = `Search Access Point`, // where the user came from: insights, funnels, dashboards, etc
  SearchQuery = `Search Query`,
  SearchReason = `Search Reason`,
  Source = `Search Source of Query`, // dropdown or modal?
  SortValue = `Sort Option`, // recent, a-z, etc
}

export enum SearchPhaseVersion {
  Old = 0,
  PhaseOne = 1,
  PhaseTwo = 2,
  PhaseThree = 3,
  AddedUniqueViewsCustomRank = 4,
}

export enum SearchSource {
  Dropdown = `Dropdown`,
  Modal = `Modal`,
  Discover = `Discover`,
}

export enum ContentDiscoveryType {
  // represents the stage of content discovery, such as browse (opening and looking for content
  // getting recent results, and the result after searching for something)
  Browse = `Browse`,
  RecentResults = `Recent Results`,
  SearchQuery = `Search Query`,
}

export function getSearchCommonTrackingProperties() {
  return {
    [SearchTrackedProperty.PhaseVersion]: SearchPhaseVersion.AddedUniqueViewsCustomRank,
    [SearchTrackedProperty.SearchAccessPoint]: capitalize(getReportName() ?? ``),
  };
}

export function getTrackingPropertiesForResult(result: SearchResult) {
  return {
    [SearchTrackedProperty.IsOwner]: result.user_id === userCookieUtils.getUserIdentityFromCookie()?.id,
    [SearchTrackedProperty.Owner]: result.user,
    [SearchTrackedProperty.PopularityScore]: result.scores.popularity,
    [SearchTrackedProperty.FinalScore]: result.scores.final,
    [SearchTrackedProperty.ReportDescription]: result.description,
    [SearchTrackedProperty.ReportTitle]: result.name,
    [SearchTrackedProperty.ReportType]: result.report,
  };
}

export function getTrackingPropertiesForResultsLoad(results: SearchResult[]) {
  return {
    [SearchTrackedProperty.ResultAmount]: results.length,
    [SearchTrackedProperty.ResultsWithPopularity]: results.filter((result) => result.scores?.popularity > 0).length,
  };
}
